import exp from '@/api/report/expense'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  expenseCategories: [],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EXPENSE_CATEGORIES(state, data) {
    state.expenseCategories = data
  },
}

export const actions = {
  expenseItem(context, data) {
    return exp.expenseItem(data)
  },
  expenseItemExcel(context, data) {
    return exp.expenseItemExcel(data)
  },
  monthlyExpenseItem(context, data) {
    return exp.monthlyExpenseItem(data)
  },
  monthlyExpenseItemExcel(context, data) {
    return exp.monthlyExpenseItemExcel(data)
  },
  productCategory(context, data) {
    return exp.category(data)
  },
  getEmployee(context, data) {
    return exp.employee(data)
  },
  getExpenseItem(context, attributes = {}) {
    return exp.getExpenseItem({ params: attributes })
  },
  dailyExpensePdf(context, data) {
    return exp.dailyExpensePdf(data)
  },
  dailyExpenseExcel(context, data) {
    return exp.dailyExpenseExcel(data)
  },
  dailyCashAdvancePdf(context, data) {
    return exp.dailyCashAdvancePdf(data)
  },
  dailyCashAdvanceExcel(context, data) {
    return exp.dailyCashAdvanceExcel(data)
  },
  getexpenseCategory(context, data) {
    return exp.expenseCategory(data)
  },
  getExpitem(context, attributes = {}) {
    return exp.expItem({ params: attributes })
  },
  getExpCategory(context, attributes = {}) {
    return exp.expCategory({ params: attributes })
  },
}
